import React from "react";

const FullArrowRightIcon = () => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.76917 2.99987L7 5.50049L6 5.00049L7.86417 3.49987L-8.74228e-08 3.50049L-8.74234e-08 2.49987L7.86417 2.49987L6 1.00049L6.5 0.00048609L9.76917 2.99987Z"
        fill="#12B6EA"
      />
    </svg>
  );
};

export default FullArrowRightIcon;
